export const TRACK_TRACE_CHANGE_TRACKING = {
  searchSavedFilter: {
    source: 'track_trace.search.saved_filter',
    id: 12438,
  },
  searchCustomer: {
    source: 'track_trace.search.customer',
    id: 12439,
  },
  searchAssignedTo: {
    source: 'track_trace.search.assigned_to',
    id: 12440,
  },
  searchCoveredBy: {
    source: 'track_trace.search.covered_by',
    id: 12441,
  },
  searchCheckCallStatus: {
    source: 'track_trace.search.check_call_status',
    id: 12442,
  },
  searchMyItems: {
    source: 'track_trace.search.my_items',
    id: 12443,
  },
  searchTracking: {
    source: 'track_trace.search.tracking',
    id: 12444,
  },
} as const;
